import { Tooltip } from "antd";

const HeaderIcons = ({
  item,
  tooltip,
  handleAlertClick,
  setVisible,
  mergedArrow,
}) => (
  <>
    <Tooltip
      placement="rightTop"
      title={tooltip}
      arrow={mergedArrow}
      color="#364048"
      onOpenChange={setVisible}
    >
      <i className="icon-Vector" style={{ paddingLeft: 10 }} />
    </Tooltip>

    <span className="alert_wrapper" style={{ paddingLeft: 10 }}>
      <i
        onClick={(e) => {
          e.stopPropagation();
          handleAlertClick(item.key, item.name, item.alert);
        }}
        className={`icon-alert ${item.alert ? "alertIconClicked" : ""}`}
      />
    </span>
  </>
);

export default HeaderIcons;
